/**
 * The Notes link's active rule. AI Notes settings and connect flows live under the Notes tab (entry point in the
 * Notes module header, NOT a top-level nav item), so the tab stays active on those subpaths. A note's own page
 * is matched by its route pattern, `[id]`, which is what `router.pathname` carries there.
 */
export const NOTES_NAV_ACTIVE_REGEX = /^(\/\[orgSlug\])?\/notes(?:\/(?:\[id\]|ai-notes(?:\/.*)?|connect\/.*))?(?:\/)?(?:\?.*)?$/;

type NavGroup = { label: string; links: { activeRegex: RegExp }[] };

/** The first group holding a link that marks `pathname` current, by the same test as the link highlight. */
export const currentNavGroupLabel = (groups: NavGroup[], pathname: string): string | null =>
  groups.find(group => group.links.some(link => link.activeRegex.test(pathname)))?.label ?? null;

/** Open sections with `label` added; the same array when it is already open or there is no group. */
export const withOpenGroup = (selections: string[], label: string | null): string[] =>
  label === null || selections.includes(label) ? selections : [...selections, label];
